/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from 'react';
import { ContactModal } from './components/ContactModal/ContactModal';
import { DemoModal } from './components/DemoModal/DemoModal';
import { HelpModal } from './components/HelpModal/HelpModal';

enum ModalStep {
  Help = 'Help',
  Demo = 'Demo',
  Contact = 'Contact',
}

export const Help = () => {
  const [modalStep, setModalStep] = useState<ModalStep | null>(null);

  return (
    <>
      <li title="Help" onClick={() => setModalStep(ModalStep.Help)}>
        <i className="fa fa-question-circle" />
      </li>

      {modalStep === ModalStep.Help && (
        <HelpModal
          onClose={() => setModalStep(null)}
          onDemo={() => setModalStep(ModalStep.Demo)}
          onContact={() => setModalStep(ModalStep.Contact)}
        />
      )}

      {modalStep === ModalStep.Demo && (
        <DemoModal onClose={() => setModalStep(null)} onBack={() => setModalStep(ModalStep.Help)} />
      )}

      {modalStep === ModalStep.Contact && (
        <ContactModal
          onClose={() => setModalStep(null)}
          onBack={() => setModalStep(ModalStep.Help)}
        />
      )}
    </>
  );
};
